const initModalVideo = () => {
    const imageVideoWidgetArray = document.querySelectorAll(".image-video-widget");
    if (imageVideoWidgetArray && imageVideoWidgetArray.length > 0) {
        const body = document.querySelector("body");
        imageVideoWidgetArray.forEach((imageVideoWidget) => {
            const wrapperImageVideo = imageVideoWidget.querySelector(".wrapper-image-video");
            const videoContainer = imageVideoWidget.querySelector(".video-container");
            const modalVideo = imageVideoWidget.querySelector(".modal-video");
            const modalCloseIcon = modalVideo.querySelector(".close-icon");
            if (videoContainer && modalVideo) {
                const iframeVideo = modalVideo.querySelector("iframe");
                const scrVideo = modalVideo.querySelector("iframe").getAttribute("src");
                videoContainer.addEventListener("click", () => {
                    wrapperImageVideo.classList.add("modal-active");
                    iframeVideo.setAttribute("src", scrVideo);
                    body.classList.add("no-scroll");
                });
                clickCloseModalVideoEvent(modalCloseIcon, wrapperImageVideo, iframeVideo, body);
                clickCloseModalVideoEvent(modalVideo, wrapperImageVideo, iframeVideo, body);
            }
        });
    }
};
const clickCloseModalVideoEvent = (elementClick, wrapperImageVideo, iframeVideo, body) => {
    elementClick.addEventListener("click", () => {
        wrapperImageVideo.classList.remove("modal-active");
        iframeVideo.setAttribute("src", "");
        body.classList.remove("no-scroll");
    });
};
